import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import Loadable from 'components/Loadable';

// public pages
const SharedStoryPage = Loadable(lazy(() => import('pages/shared-story/index')));

// ==============================|| PUBLIC ROUTES ||============================== //

const PublicRoutes = {
  path: '/story/:shareToken',
  element: <SharedStoryPage />
};

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes, PublicRoutes], { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
